function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';
import validateName from './validator';
import TextField from '../text-field';

/**
 * Name field wrapper. It accepts following handlers
 * - handleChange for setting value change and
 * - handleErrorChange for setting error
 *
 * It is responsible for
 * - Performing name field validations
 * - Clearing error on focus
 * - Setting value on change
 */
const NameField = props => {
  const {
    formatMessage
  } = useIntl();
  const {
    handleErrorChange,
    errorMessage = '',
    handleFocus
  } = props;
  const handleOnBlur = e => {
    const {
      value
    } = e.target;
    const fieldError = validateName(value, formatMessage);
    if (fieldError) {
      handleErrorChange('name', fieldError);
    }
  };
  const handleOnFocus = () => {
    handleErrorChange('name', '');
    handleFocus('', 'name');
  };
  return /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    errorMessage: errorMessage,
    handleBlur: handleOnBlur,
    handleFocus: handleOnFocus
  }));
};
NameField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired
};
export default NameField;
//# sourceMappingURL=index.js.map